export function OutlineGroupFilesIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0672 13.2048V18.9072C12.0672 20.064 11.16 21 10.0416 21H5.0256C3.9072 21 3 20.064 3 18.9072V11.0928C3 9.9408 3.9072 9 5.0256 9H8.0064C8.544 9 9.0576 9.2256 9.4416 9.6192L11.472 11.7216C11.856 12.1152 12.0672 12.648 12.0672 13.2048Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M21.1346 7.2048V12.9072C21.1346 14.064 20.2274 15 19.109 15H16.5986V10.2048C16.5986 9.648 16.3874 9.1152 16.0082 8.7216L13.973 6.6192C13.5938 6.2256 13.0754 6 12.5426 6H12.0674V5.0928C12.0674 3.9408 12.9746 3 14.093 3H17.0738C17.6114 3 18.125 3.2256 18.5042 3.6192L20.5394 5.7216C20.9186 6.1152 21.1346 6.648 21.1346 7.2048Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M16.5985 10.2048V15.9072C16.5985 17.064 15.6961 18 14.5777 18H12.0673V13.2048C12.0673 12.648 11.8561 12.1152 11.4721 11.7216L9.44173 9.6192C9.05773 9.2256 8.54413 9 8.00653 9H7.53613V8.0928C7.53613 6.9408 8.43853 6 9.55693 6H12.5425C13.0753 6 13.5937 6.2256 13.9729 6.6192L16.0081 8.7216C16.3873 9.1152 16.5985 9.648 16.5985 10.2048Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
